export default {
    locating: 'Locating',
    locationPromptHeading : 'Device current location permission',
    locationDisplayText :'Allow app to get your current location',
    askMeLater: 'Ask Me Later',
    locationService: 'Location Service',
    locationPermissionDenied: 'Location permission denied.',
};